import React from 'react';
import PropTypes from 'prop-types';
import hash from 'object-hash';

const DropdownA = (props) => {
  const {
    type,
    options,
    defaultValue,
    onChange,
    onInputChange,
    onKeyDown,
    renderOption,
    renderSingleValue,
    isSearchable = false,
    isClearable = false,
    placeholder = 'Select...',
    value,
    customStyles = {},
  } = props;

  // HACK - for bug in react-select (https://github.com/JedWatson/react-select/issues/3802)
  if (typeof window === 'undefined') {
    return null;
  }
  const { default: Select, components } = require('react-select'); // eslint-disable-line global-require
  const { Option, SingleValue } = components;
  // HACK - end

  const OptionComponent = (optionProps) => (
    <Option {...optionProps}>
      {renderOption && optionProps.data[renderOption]}
    </Option>
  );

  const SingleValueComponent = (singleValueProps) => (
    <SingleValue {...singleValueProps}>
      {renderSingleValue && singleValueProps.data[renderSingleValue]}
    </SingleValue>
  );

  const styles = {
    option: (base, { isFocused, isSelected }) => (type === 'NavDropdown'
      ? { backgroundColor: isFocused || isSelected ? '#F9F9F9' : null }
      : (renderSingleValue && {}) || { ...base }),
    container: (base) => ({ ...base, width: '100%', border: 'none', height: '50px' }),
    control: (base) => ({ ...base, border: '1px solid #222121', borderRadius: '4px', height: '100%' }),
    menu: (base) => ({ ...base, marginTop: '1px' }),
  };

  return (
    <Select
      defaultValue={defaultValue}
      value={value}
      options={options}
      components={{ Option: OptionComponent, SingleValue: SingleValueComponent }}
      onChange={onChange}
      onInputChange={onInputChange}
      onKeyDown={onKeyDown}
      isSearchable={isSearchable}
      isClearable={isClearable}
      styles={{ ...styles, ...customStyles }}
      placeholder={placeholder}
      instanceId={hash(type)}
      openMenuOnFocusboolean
      blurInputOnSelect
      closeMenuOnSelect
      aria-label={placeholder}
    />
  );
};

DropdownA.propTypes = {
  type: PropTypes.string,
  options: PropTypes.array,
  defaultValue: PropTypes.object,
  onChange: PropTypes.func,
  onInputChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  renderOption: PropTypes.string,
  renderSingleValue: PropTypes.string,
  isSearchable: PropTypes.bool,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.object,
  customStyles: PropTypes.object,
};

export default DropdownA;
